import React, { useMemo, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { Programming, UpdateProgrammingRequest } from '../../models/programming';
import { ShortDto } from '../../models/short-dto';
import ProgrammingForm from '../../pages/backoffice/programming/components/ProgrammingForm';
import ProgrammingTripClosureSummary from './ProgrammingTripClosureSummary';
import { toUpdateProgrammingRequest } from './programming-list-spreadsheet';

export interface TorreQuickEditLookups {
    clients: ShortDto[];
    vehiclePlates: ShortDto[];
    products: ShortDto[];
    drivers: ShortDto[];
    references: ShortDto[];
    routes: ShortDto[];
}

interface ProgrammingTorreQuickEditModalProps {
    open: boolean;
    programming: Programming | null;
    lookups: TorreQuickEditLookups;
    lockedClientId?: string;
    loading?: boolean;
    onClose: () => void;
    onSave: (id: string, payload: UpdateProgrammingRequest) => Promise<void>;
}

const ProgrammingTorreQuickEditModal: React.FC<ProgrammingTorreQuickEditModalProps> = ({
    open,
    programming,
    lookups,
    lockedClientId,
    loading = false,
    onClose,
    onSave,
}) => {
    const [error, setError] = useState<string>();

    const initial = useMemo(() => programming, [programming?.id]);

    if (!initial) return null;

    return (
        <Modal open={open} onClose={onClose} closeIcon size="large">
            <Modal.Header>Editar programação — {initial.mainVehiclePlateName || initial.id}</Modal.Header>
            <Modal.Content scrolling>
                <ProgrammingTripClosureSummary programming={initial} compact />
                <ProgrammingForm
                    variant="torre"
                    isEdit
                    initialData={initial}
                    loading={loading}
                    error={error}
                    clients={lookups.clients}
                    vehiclePlates={lookups.vehiclePlates}
                    products={lookups.products}
                    drivers={lookups.drivers}
                    references={lookups.references}
                    routes={lookups.routes}
                    lockedClientId={lockedClientId}
                    clientDisabled={Boolean(lockedClientId)}
                    onCancel={onClose}
                    onSubmit={async (data) => {
                        try {
                            setError(undefined);
                            const payload = toUpdateProgrammingRequest(initial, {
                                ...data,
                                auditSource: 'torre-quick-edit',
                            } as Partial<UpdateProgrammingRequest>);
                            await onSave(initial.id, payload);
                            onClose();
                        } catch (e: unknown) {
                            setError(e instanceof Error ? e.message : 'Falha ao salvar');
                        }
                    }}
                />
            </Modal.Content>
        </Modal>
    );
};

export default ProgrammingTorreQuickEditModal;
